module.exports = __webpack_public_path__ + "static/media/light-whatsapp.2931c3e6.jpg";